<template>
  <div class="bg-gray-400">
    <div class="max-w-7xl mx-auto py-12 sm:px-6 lg:px-8">
      <div class="max-w-4xl mx-auto">
        <div class="bg-white shadow overflow-hidden sm:rounded-lg mx-auto mb-10">
          <div class="mb-5 px-4 py-5 border-gray-200 sm:px-6 mx-auto">
            <h3
              class="text-3xl leading-6 font-medium text-gray-900 text-center"
            >Offerte Super</h3>
            <p
              class="mt-5 mx-auto max-w-2xl text-sm leading-5 text-gray-500 text-center"
            >Le migliori offerte dai canali di shopping</p>
          </div>
        </div>
        <div
          v-for="(day,i) in days"
          :key="i"
          class="bg-white shadow overflow-hidden sm:rounded-lg mx-auto mb-10"
        >
          <div class="mb-5 px-4 py-5 border-gray-200 sm:px-6 mx-auto">
            <p
              class="mt-5 font-semibold max-w-2xl text-lg leading-5 text-gray-800"
            >{{ [ day.date, "YYYYMMDD" ] | moment(" D MMMM YYYY")}}</p>
          </div>
          <div
            v-for="(message, index) in day.messages"
            :key="index"
            class="md:flex bg-white rounded-lg p-6"
          >
            <img class="h-64 md:h-32 max-h-xs mx-auto md:mx-0 md:mr-6" :src="message.data.imageUrl" />
            <div class="md:text-left">
              <a :href="message.data.linkUrl" target="_blank">
                <h2 class="text-lg text-gray-900 font-bold">{{message.data.title | removeSlash}}</h2>
              </a>
              <div
                class="text-green-800 font-semibold"
              >💵 {{message.data.prezzoInOfferta}}{{message.data.isSconto ? ' invece di ' + message.data.prezzoConsigliato : ''}} {{message.data.sconto ? 'risparmio ' + removeSlash(message.data.sconto) : ''}}</div>
              <div
                v-if="message.data.spedizioneGratuita"
                class="text-gray-800"
              >🚚 {{message.data.spedizioneGratuita | removeSlash}}</div>
              <div class="text-gray-800">{{message.data.amazonChoice | removeSlash}}</div>
              <div
                class="text-gray-800"
              >⭐{{message.data.stars | removeSlash}} {{message.data.recensioni | removeSlash}}</div>
              <div class="text-gray-800 text-xs">{{message.data.sezioni | joinSections}}</div>
            </div>
          </div>
        </div>
        <div class="bg-white shadow overflow-hidden sm:rounded-lg mx-auto mt-5">
          <div class="px-4 py-5 border-b border-gray-200 sm:px-6 mx-auto">
            <p
              class="mt-5 mx-auto max-w-2xl text-sm leading-5 text-gray-500 text-center"
            >In qualità di affiliati Amazon riceviamo un guadagno dagli acquisti idonei</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "home",
  data() {
    return {
      days: {}
    };
  },
  methods: {
    removeSlash(value) {
      return (value || "").replace(/(\\)/gm, "") || "";
    },
    getMessages() {
      const date = new Date();
      date.getFullYear()
      axios
        .get("https://super-deals-b855d.firebaseio.com/messages.json?orderBy=\"$key\"&limitToLast=2")
        .then(response => {
          let pippo = response.data;
          const stringaData = date.getFullYear() + '' + (date.getMonth() + 1) + '' + date.getDate()
          this.days = Object.keys(pippo).filter( k => {
                  //console.log(stringaData,k, stringaData == k)
            return stringaData == k
              }).map(k => {
            let messaggi = pippo[k];
            messaggi = Object.keys(messaggi)
              .map(m => messaggi[m])
              .filter(s => s.data || false).reverse();
            return { date: k, messages: messaggi };
          }).reverse();
        });
    }
  },
  filters: {
    removeSlash: function(value) {
      return (value || "").replace(/(\\)/gm, "") || "";
    },
    joinSections: function(val) {
      return (val || []).map(s => s.name).join(" > ");
    }
  },

  mounted() {
    this.$moment.locale("it");
    this.getMessages();
  }
};
</script>
